import { createLucideIcon } from "lucide-react";

export const Connect = createLucideIcon(
    "Connect",
    [
        [
            "path",
            {
                d: "M1.4697 21.4697C1.1768 21.7626 1.1768 22.2374 1.4697 22.5303C1.7626 22.8232 2.2374 22.8232 2.5303 22.5303L1.4697 21.4697Z",
                key: "1gmr10",
            },
        ],
        [
            "path",
            {
                d: "M10.5 9.5L11.0303 10.0303L12.5303 8.5303L12 8L11.4697 7.4697L9.9697 8.9697L10.5 9.5Z",
                key: "11dcrf",
            },
        ],
        [
            "path",
            {
                d: "M11.5123 5.2292L10.9819 4.6988H10.9819L11.5123 5.2292Z",
                key: "1eww7t",
            },
        ],
        [
            "path",
            {
                d: "M11.5123 7.4067L10.9819 7.9371L11.5123 7.4067Z",
                key: "ee03dq",
            },
        ],
        [
            "path",
            {
                d: "M11.5123 7.4067L10.9819 7.9371L16.0629 13.0181L16.5933 12.4877L17.1236 11.9574L12.0426 6.8764L11.5123 7.4067Z",
                key: "ucz86l",
            },
        ],
        [
            "path",
            {
                d: "M11.5123 7.4067L12.0426 6.8764C11.8131 6.6469 11.7519 6.4553 11.75 6.3233C11.7482 6.1962 11.7993 6.0028 12.0426 5.7595L11.5123 5.2292L10.9819 4.6988C10.521 5.1598 10.2413 5.7244 10.2502 6.3447C10.259 6.9601 10.55 7.5051 10.9819 7.9371L11.5123 7.4067Z",
                key: "19gcj7",
            },
        ],
        [
            "path",
            {
                d: "M11.7619 19.4967L11.2316 18.9664C9.5201 20.6779 6.7451 20.6779 5.0336 18.9664L4.5033 19.4967L3.973 20.027C6.2703 22.3243 9.9949 22.3243 12.2922 20.027L11.7619 19.4967Z",
                key: "1upz3o",
            },
        ],
        [
            "path",
            {
                d: "M12.2381 4.5033L11.7078 3.973L10.9819 4.6988L11.5123 5.2292L12.0426 5.7595L12.7684 5.0336L12.2381 4.5033Z",
                key: "1j1jrm",
            },
        ],
        [
            "path",
            {
                d: "M12.2381 4.5033L12.7684 5.0336C14.48 3.3221 17.2549 3.3221 18.9664 5.0336L19.4967 4.5033L20.027 3.973C17.7297 1.6757 14.0051 1.6757 11.7078 3.973L12.2381 4.5033Z",
                key: "1n70bs",
            },
        ],
        [
            "path",
            {
                d: "M12.2381 4.5033L12.7684 5.0336L12.2381 4.5033Z",
                key: "1mikia",
            },
        ],
        [
            "path",
            {
                d: "M12.4877 16.5933L11.9574 17.1236L12.4877 16.5933Z",
                key: "o2ch9e",
            },
        ],
        [
            "path",
            {
                d: "M12.4877 18.7708L11.9574 18.2405L11.2316 18.9664L11.7619 19.4967L12.2922 20.027L13.0181 19.3012L12.4877 18.7708Z",
                key: "1m2u3t",
            },
        ],
        [
            "path",
            {
                d: "M12.4877 18.7708L13.0181 19.3012C13.45 18.8692 13.741 18.3242 13.7498 17.7088C13.7587 17.0885 13.479 16.5239 13.0181 16.0629L12.4877 16.5933L11.9574 17.1236C12.2007 17.3669 12.2518 17.5603 12.25 17.6874C12.2481 17.8194 12.1869 18.011 11.9574 18.2405L12.4877 18.7708Z",
                key: "19hkui",
            },
        ],
        [
            "path",
            {
                d: "M12.5303 8.5303C12.8232 8.2374 12.8232 7.7626 12.5303 7.4697C12.2374 7.1768 11.7626 7.1768 11.4697 7.4697L12.5303 8.5303Z",
                key: "q3xzfr",
            },
        ],
        [
            "path",
            {
                d: "M13.9697 12.9697C13.6768 13.2626 13.6768 13.7374 13.9697 14.0303C14.2626 14.3232 14.7374 14.3232 15.0303 14.0303L13.9697 12.9697Z",
                key: "2kblty",
            },
        ],
        [
            "path",
            {
                d: "M14.5 13.5L15.0303 14.0303L16.5303 12.5303L16 12L15.4697 11.4697L13.9697 12.9697L14.5 13.5Z",
                key: "y9iso9",
            },
        ],
        [
            "path",
            {
                d: "M16.5303 12.5303C16.8232 12.2374 16.8232 11.7626 16.5303 11.4697C16.2374 11.1768 15.7626 11.1768 15.4697 11.4697L16.5303 12.5303Z",
                key: "1j098z",
            },
        ],
        [
            "path",
            {
                d: "M16.5933 12.4877L17.1236 11.9574L16.5933 12.4877Z",
                key: "153q14",
            },
        ],
        [
            "path",
            {
                d: "M18.7708 12.4877L18.2405 11.9574C18.011 12.1869 17.8194 12.2481 17.6874 12.25C17.5603 12.2518 17.3669 12.2007 17.1236 11.9574L16.5933 12.4877L16.0629 13.0181C16.5239 13.479 17.0885 13.7587 17.7088 13.7498C18.3242 13.741 18.8692 13.45 19.3012 13.0181L18.7708 12.4877Z",
                key: "1mer38",
            },
        ],
        [
            "path",
            {
                d: "M18.7708 12.4877L19.3012 13.0181L18.7708 12.4877Z",
                key: "1yzw6b",
            },
        ],
        [
            "path",
            {
                d: "M18.7708 12.4877L19.3012 13.0181L20.027 12.2922L19.4967 11.7619L18.9664 11.2316L18.2405 11.9574L18.7708 12.4877Z",
                key: "4vbb16",
            },
        ],
        [
            "path",
            {
                d: "M19.4697 3.4697C19.1768 3.7626 19.1768 4.2374 19.4697 4.5303C19.7626 4.8232 20.2374 4.8232 20.5303 4.5303L19.4697 3.4697Z",
                key: "1ogan9",
            },
        ],
        [
            "path",
            {
                d: "M19.4967 11.7619L18.9664 11.2316H18.9664L19.4967 11.7619Z",
                key: "ux11il",
            },
        ],
        [
            "path",
            {
                d: "M19.4967 11.7619L20.027 12.2922C22.3243 9.9949 22.3243 6.2703 20.027 3.973L19.4967 4.5033L18.9664 5.0336C20.6779 6.7451 20.6779 9.5201 18.9664 11.2316L19.4967 11.7619Z",
                key: "1t031s",
            },
        ],
        [
            "path",
            {
                d: "M22 2L21.4697 1.4697L19.4697 3.4697L20 4L20.5303 4.5303L22.5303 2.5303L22 2Z",
                key: "1xi53u",
            },
        ],
        [
            "path",
            {
                d: "M22.5303 2.5303C22.8232 2.2374 22.8232 1.7626 22.5303 1.4697C22.2374 1.1768 21.7626 1.1768 21.4697 1.4697L22.5303 2.5303Z",
                key: "748msr",
            },
        ],
        [
            "path",
            {
                d: "M4 20L3.4697 19.4697L1.4697 21.4697L2 22L2.5303 22.5303L4.5303 20.5303L4 20Z",
                key: "1abyhk",
            },
        ],
        [
            "path",
            {
                d: "M4.5033 12.2381L3.973 11.7078C1.6757 14.0051 1.6757 17.7297 3.973 20.027L4.5033 19.4967L5.0336 18.9664C3.3221 17.2549 3.3221 14.48 5.0336 12.7684L4.5033 12.2381Z",
                key: "1ygrct",
            },
        ],
        [
            "path",
            {
                d: "M4.5033 12.2381L5.0336 12.7684L5.7595 12.0426L5.2292 11.5123L4.6988 10.9819L3.973 11.7078L4.5033 12.2381Z",
                key: "pht7pi",
            },
        ],
        [
            "path",
            {
                d: "M4.5033 12.2381L5.0336 12.7684V12.7684L4.5033 12.2381Z",
                key: "6pgdty",
            },
        ],
        [
            "path",
            {
                d: "M4.5303 20.5303C4.8232 20.2374 4.8232 19.7626 4.5303 19.4697C4.2374 19.1768 3.7626 19.1768 3.4697 19.4697L4.5303 20.5303Z",
                key: "7iqmua",
            },
        ],
        [
            "path",
            {
                d: "M5.2292 11.5123L4.6988 10.9819L4.6988 10.9819L5.2292 11.5123Z",
                key: "1kf7s2",
            },
        ],
        [
            "path",
            {
                d: "M7.4067 11.5123L6.8764 12.0426L11.9574 17.1236L12.4877 16.5933L13.0181 16.0629L7.9371 10.9819L7.4067 11.5123Z",
                key: "rsl0x9",
            },
        ],
        [
            "path",
            {
                d: "M7.4067 11.5123L7.9371 10.9819C7.5051 10.55 6.9601 10.259 6.3447 10.2502C5.7244 10.2413 5.1598 10.521 4.6988 10.9819L5.2292 11.5123L5.7595 12.0426C6.0028 11.7993 6.1962 11.7482 6.3233 11.75C6.4553 11.7519 6.6469 11.8131 6.8764 12.0426L7.4067 11.5123Z",
                key: "ul9i3b",
            },
        ],
        [
            "path",
            {
                d: "M7.4067 11.5123L7.9371 10.9819L7.4067 11.5123Z",
                key: "1tbjh5",
            },
        ],
        [
            "path",
            {
                d: "M9.9697 8.9697C9.6768 9.2626 9.6768 9.7374 9.9697 10.0303C10.2626 10.3232 10.7374 10.3232 11.0303 10.0303L9.9697 8.9697Z",
                key: "h4q521",
            },
        ],
    ],
);
